import * as React from "react";
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from "@mui/material/CssBaseline";
import Link from '@mui/material/Link';
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { parse } from 'cookie';
import { useNavigate } from 'react-router-dom';
import '../../Css/Global/Global.css';
import LoginSide from "./LoginSide";
import TwoFactorForm from "./TwoFactoryForm";
import {getToken} from "../../Storages/cookies";
import theme from "../../Components/theme";

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://tribunex.com.br/">
                TribuNex
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const Login: React.FC = () => {
    const [twoFactor, setTwoFactor] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (getToken()) {
            navigate('/');
        }
    }, []);

    if(getToken()) {
        return (<Grid sx={{m: 2}}>
            <p>Aguarde, estamos te redirecionando...</p>
        </Grid>);
    }

    return (
        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{
                height: '100vh',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#1c2e4a'
            }}>
                <CssBaseline />
                <Grid item xs={12} sm={12} md={4} component={Paper} square>
                    {twoFactor ? (
                        <TwoFactorForm setTwoFactor={setTwoFactor}/>
                    ): (
                        <LoginSide setTwoFactor={setTwoFactor} twoFactor={twoFactor} />
                    )}
                </Grid>
            </Grid>

        </ThemeProvider>
    );
}


export default Login;